<template>
  <div @click.self="closeModal" class="fixed inset-0 z-50 overflow-auto bg-gray-900 bg-opacity-50 flex justify-center items-center">
    <div @click.stop class="h-4/5 w-5/6 bg-white flex flex-col p-3">
    
      <div class="flex flex-col h-full w-full gap-2">
        <div class="">
          <p class="text-md font-bold text-gray-700 text-center">Global Attribute</p>
        </div>
        <div class="w-full flex flex-col justify-betweem">
          <div class="flex justify-center gap-5 mb-4">
            <input type="text" v-model="searchGlobalCode" placeholder="Search Global Attribute Code" class="px-2 py-1 border border-gray-500 rounded-sm w-96">
            <input type="text" v-model="searchGlobalName" placeholder="Search Global Attribute Name" class="px-2 py-1 border border-gray-500 rounded-sm w-96">
          </div>

          <div class="flex w-full xl:max-h-[350px] 2xl:max-h-[450px] max-h-[280px] overflow-auto">
            <table class="border-2 w-full border-slate-950">
              <thead>
                <tr class="text-left">
                  <th>Global Attribute Code</th>
                  <th>Global Attribute Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in filteredGlobalName" :key="item.id">
                  <td class="border-y border-gray-400">{{ item.globalattributeCode }}</td>
                  <td class="border-y border-gray-400">{{ item.globalattributeName }}</td>
                  <td class="border-y border-gray-400 flex flex-row flex-wrap gap-2">
                    <!-- <div class=""> -->
                        <button @click="editGlobal(item)" class="px-2 py-1 bg-yellow-500 text-white rounded-sm">Edit</button>
                        <button @click="deleteGlobal(item)" class="px-2 py-1 bg-red-500 text-white rounded-sm">Delete</button>
                    <!-- </div> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <modalEditGlobal v-if="openEditGlobal" :global="dataEditGlobal" @close="closeModalEdit"/>
  </div>
</template>

<script>
import ModalEditGlobal from '@/utils/masterdata/globalAttribute/ModalEditGlobal.vue';
export default {
    components: {
        ModalEditGlobal
    },
  data() {
    return {
      searchGlobalCode: '',
      searchGlobalName: '',
      dataEditGlobal: null,
      openEditGlobal: false
    };
  },
  methods: {
    closeModal(event) {
      if (event.target.classList.contains('bg-gray-900')) {
        this.$emit('close'); //close
      }
    },
    closeModalEdit() {
        this.openEditGlobal = false
    },
    editGlobal(item) {
        console.log(item);
        this.dataEditGlobal = item
        this.openEditGlobal = true
    },
    deleteGlobal(item) {
        try {
            console.log('item id',item.id);
            this.$store.dispatch('deleteGlobal', item.id)
            this.$toast.success('Berhasil Menghapus Global Attribute', {
                    duration: 2500,
                    position: 'top-right'
                });
        } catch (error) {
            this.$toast.error(`Gagal Menghapus data Global Attribute, ${error}`, {
                    duration: 2500,
                    position: 'top-right'
                });
        }
    }
  },
  computed: {
    globalAttributeData() {
      return this.$store.getters.getGlobalAttributes;
    },

    filteredGlobal() {
      if (!this.searchGlobalCode) {
                return this.globalAttributeData;
            }
            let searchTerms = this.searchGlobalCode.toLowerCase().split(/\s+|\|\|/).filter(term => term.trim() !== '');

            let filteredGlobal = this.globalAttributeData;

            searchTerms.forEach(term => {
                if (term.includes("||")) {
                    const keywords = term.split("||").map(keyword => keyword.trim());
                    filteredGlobal = filteredGlobal.filter(data => {
                        return keywords.every(keyword => {
                            return data.globalattributeCode.toLowerCase().includes(keyword);
                        });
                    });
                } else if (term.includes("|")) {
                    const keywords = term.split("|").map(keyword => keyword.trim());
                    filteredGlobal = filteredGlobal.filter(data => {
                        return keywords.some(keyword => {
                            return data.globalattributeCode.toLowerCase().includes(keyword);
                        });
                    });
                } else {
                    filteredGlobal = filteredGlobal.filter(data => {
                        return data.globalattributeCode.toLowerCase().includes(term);
                    });
                }
            });

            return filteredGlobal;
    },
    filteredGlobalName() {
      if (!this.searchGlobalName) {
                return this.filteredGlobal;
            }
            let searchTerms = this.searchGlobalName.toLowerCase().split(/\s+|\|\|/).filter(term => term.trim() !== '');

            let filteredGlobalName = this.filteredGlobal;

            searchTerms.forEach(term => {
                if (term.includes("||")) {
                    const keywords = term.split("||").map(keyword => keyword.trim());
                    filteredGlobalName = filteredGlobalName.filter(data => {
                        return keywords.every(keyword => {
                            return data.globalattributeName.toLowerCase().includes(keyword);
                        });
                    });
                } else if (term.includes("|")) {
                    const keywords = term.split("|").map(keyword => keyword.trim());
                    filteredGlobalName = filteredGlobalName.filter(data => {
                        return keywords.some(keyword => {
                            return data.globalattributeName.toLowerCase().includes(keyword);
                        });
                    });
                } else {
                    filteredGlobalName = filteredGlobalName.filter(data => {
                        return data.globalattributeName.toLowerCase().includes(term);
                    });
                }
            });

            return filteredGlobalName;
    }
  },
  mounted() {
    this.$store.dispatch('fetchGlobalAttributeData')
    console.log('global data',this.globalAttributeData);
  }
};
</script>